import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  

  logo: {
    width: 'auto', // This will maintain the aspect ratio
    height: 50, // adjust the height as needed

  },
});
const LogoFullWhite = () => {
  const classes = useStyles();
  return <img src='vf-logo-white.png' alt="Vodafone Logo" className={classes.logo}/>
};

export default LogoFullWhite;
